import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {Badge, Typography, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import ProtocolsFormFields from './ProtocolsFormFields';
class ProtocolsForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            online: navigator.onLine,
        };
    }

    updateOnlineStatus = () => {
        var status = navigator.onLine ? true : false;
        this.setState({online: status});
    };

    componentDidMount() {
        window.addEventListener('online',  this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
    }
    componentWillUnmount() {
        window.removeEventListener('offline', this.updateOnlineStatus);
        window.removeEventListener('online', this.updateOnlineStatus);
    }

    render() {
        const {
            values,
            customer,
            appointment,
            structure,
            classes
        } = this.props;

        values.online = this.state.online;

        return (
            <React.Fragment>
                {this.state.online ? (
                    <Badge badgeContent={"ONLINE"} classes={{badge: classes.onlineStatus}}/>
                ) : (
                    <Badge badgeContent={"OFFLINE"} classes={{badge: classes.offlineStatus}}/>
                )}

                <ProtocolsFormFields {...this.props}/>

            </React.Fragment>
        )

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            customer_id: props.customer.id,
            customer_name: props.customer.customer_name,
            appointment_id: props.appointment.id,
            appointment_name: props.appointment.appointment_name,
            structure_id: props.structure.id,
            structure_name: props.structure.structure_name,
            inspection_tag: ''
            // legal_regulation: '',
            // name: '',
            // machine_id: '',
            // machine: null,
        });
    },

    // validationSchema: () => {
    //     let rules = object().shape({
    //         salutation: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.salutation')})
    //         ),
    //         first_name: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
    //         ),
    //         last_name: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.last_name')})
    //         ),
    //
    //         street: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.street')})
    //         ),
    //         housenumber: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.housenumber')})
    //         ),
    //         zip: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.zip')})
    //         ),
    //         city: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.city')})
    //         ),
    //     });
    //
    //     return rules
    // },

    handleSubmit: (values, {props}) => {

        if (values.online) {
            axios.post(props.formUrl, values).then(() => {
                swal({
                    icon: "success",
                    title: i18n.get('protocols.save_success'),
                    text: i18n.get('protocols.you_will_be_redirected'),
                    timer: 4000,
                }).then(() => {
                    window.location.href = props.redirectAfterSubmit
                })
            }).catch(() => {
                swal({
                    icon: "error",
                    title: i18n.get('protocols.ajax_error'),
                })
            })
        } else {
            const dataSerialized = JSON.stringify(values);
            const keyName = 'protocol_' + Date.now() + Math.random();
            localStorage.setItem(keyName, dataSerialized);
            window.location.href = "/offline-zone"
        }
    },

    validateOnBlur: true

})(ProtocolsForm)

const styles = theme => ({
    // deleteButton: {
    //     // background: theme.colors.error
    // }

    onlineStatus: {
        backgroundColor: "green",
        color: "white",
        fontWeight: "normal",
    },
    offlineStatus: {
        backgroundColor: "red",
        color: "white",
        fontWeight: "normal",
    },
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/ProtocolsForm.js